import { render, staticRenderFns } from "./market-item-orders-table.vue?vue&type=template&id=80bcbf32&scoped=true"
import script from "./market-item-orders-table.vue?vue&type=script&lang=js"
export * from "./market-item-orders-table.vue?vue&type=script&lang=js"
import style0 from "./market-item-orders-table.vue?vue&type=style&index=0&id=80bcbf32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bcbf32",
  null
  
)

export default component.exports